<script>
    import likert_choices from "./questions/likert_choices.json";

    export let questionset_id;
    export let user_language;
    export let responses;
    export let question;

    let { question_id, valence, question_text } = question;

    // scores for 7-point likert scale with positive valence
    let response_options = [
        "10.00",
        "8.33",
        "6.67",
        "5.00",
        "3.33",
        "1.67",
        "0.00",
    ];

    // if valence is reversed, reverse the scores
    if (valence === "negative") {
        response_options.reverse();
    }
</script>

<div class="row response_values">
    <div class="statement">&nbsp;</div>
    <div class="response">{likert_choices["7"][user_language]}</div>
    <div class="response">{likert_choices["6"][user_language]}</div>
    <div class="response">{likert_choices["5"][user_language]}</div>
    <div class="response">{likert_choices["4"][user_language]}</div>
    <div class="response">{likert_choices["3"][user_language]}</div>
    <div class="response">{likert_choices["2"][user_language]}</div>
    <div class="response">{likert_choices["1"][user_language]}</div>
    <div class="response na">{likert_choices["NA"][user_language]}</div>
</div>

<div class="row">
    <div class="statement">{question_text[user_language]}</div>

    {#each response_options as value, idx}
        <div class="response">
            <label for="{question_id}_{idx}">
                <input
                    type="radio"
                    name={question_id}
                    id="{question_id}_{idx}"
                    value={parseFloat(value)}
                    bind:group={responses[questionset_id][question_id]}
                />
            </label>
        </div>
    {/each}
    <div class="response na">
        <label for="{question_id}_na">
            <input
                type="radio"
                name={question_id}
                id="{question_id}_na"
                value={parseFloat("-1")}
                class="na"
                bind:group={responses[questionset_id][question_id]}
            />
        </label>
    </div>
</div>

<style lang="scss">
    .row {
        display: flex;
        align-items: center;
        padding: 1em 0;
        border-bottom: 1px solid lightgray;
        min-width:900px;

        &:last-of-type {
            border-bottom: none;
        }

        .response {
            padding-inline: 0.25rem;
            font-size: 12px;
            width: 8.5%;
            text-align: center;

            &.na {
                color: var(--color-grey-med);
                font-style: italic;
            }
        }
    }

    .row.response_values {
        &:first-of-type {
            align-items: end;
        }

        &:not(:first-of-type) {
            display: none;
        }
    }

    .statement {
        width: 32%;
    }

    label {
        cursor: pointer;
        display:block;
        width:100%;
        padding-top:1rem;
        padding-bottom:1rem;
    }

    input[type="radio"] {
        transform: scale(1.5);
        cursor: pointer;
        &.na {
            opacity: 0.5;
            filter: saturate(0);
        }
    }
</style>
